import {
  MOSCOW_AREA_REGION_ID,
  MOSCOW_AREA_REGION_NAME,
  MOSCOW_REGION_ID,
  MOSCOW_REGION_NAME,
  MOSCOW_WITH_AREA_REGION_ID,
  ST_PETERSBURG_AREA_REGION_ID,
  ST_PETERSBURG_AREA_REGION_NAME,
  ST_PETERSBURG_REGION_ID,
  ST_PETERSBURG_REGION_NAME,
  ST_PETERSBURG_WITH_AREA_REGION_ID,
} from '../../constants/region';
import { IPopularCitiesForGeoPopupResponseSchema } from '../../repositories/geo-suggest/entities/entities/PopularCitiesForGeoPopupResponseSchema';
import { IRegion } from '../../types/requestForm';

/**
 * Временно заменяем Москву и МО на Москву, Санкт-Петербург и ЛО на Санкт-Петербург
 * @todo выпилить, когда апишка перестанет возвращать кастомные регионы, которые отсутствуют в базе
 */
export const preparePopularRegions = (response: IPopularCitiesForGeoPopupResponseSchema): IRegion[] => {
  const regionsMap = response.cities.reduce((acc, city) => {
    if (city.id === MOSCOW_WITH_AREA_REGION_ID) {
      acc.set(MOSCOW_REGION_ID, {
        id: MOSCOW_REGION_ID,
        label: MOSCOW_REGION_NAME,
      });

      acc.set(MOSCOW_AREA_REGION_ID, {
        id: MOSCOW_AREA_REGION_ID,
        label: MOSCOW_AREA_REGION_NAME,
      });

      return acc;
    }

    if (city.id === ST_PETERSBURG_WITH_AREA_REGION_ID) {
      acc.set(ST_PETERSBURG_REGION_ID, {
        id: ST_PETERSBURG_REGION_ID,
        label: ST_PETERSBURG_REGION_NAME,
      });

      acc.set(ST_PETERSBURG_AREA_REGION_ID, {
        id: ST_PETERSBURG_AREA_REGION_ID,
        label: ST_PETERSBURG_AREA_REGION_NAME,
      });

      return acc;
    }

    acc.set(city.id, {
      id: city.id,
      label: city.displayName,
    });

    return acc;
  }, new Map<number, IRegion>());

  return Array.from(regionsMap.values());
};
